import styled from 'styled-components'

const Styled = styled.div`
  .ant-table-sticky-holder {
    top: 80px !important;
  }
`

export default Styled
